<template>
  <v-card class="primary align-center" width="100%" height="100%">
    <v-card-text class="primary">
      <v-card-title class="primary mt-16">
        <v-img
          alt="Psycp Logo"
          contain
          src="@/assets/LogoVertical.png"
          transition="scale-transition"
          height="140"
          class="mt-16"
        />
      </v-card-title>
      <v-card-text class="black--text align-text text-h7 text-center mt-3 pa-2">
        Se realizó correctamente
      </v-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HomeConfirmation',
  data() {
    return {};
  },
};
</script>
